import type { AttentionSummary } from '../lib/verificationView';

/**
 * What needs an admin's eyes, counted from the live views. Quiet when all is well and before the
 * first snapshot; says so plainly when live updates are unavailable (the table keeps showing
 * the last known data).
 */
export function VerificationAttentionBanner({
  summary,
  live,
  error,
}: {
  summary: AttentionSummary;
  live: boolean;
  error: string | null;
}) {
  const parts: string[] = [];
  if (summary.needsReview) {
    const who = summary.needsReviewNames.length ? ` (${summary.needsReviewNames.join(', ')})` : '';
    parts.push(`${summary.needsReview} need review${who}`);
  }
  if (summary.failed) parts.push(`${summary.failed} failed`);
  if (summary.manualReview) parts.push(`${summary.manualReview} manual review`);
  const unavailable = !live && error !== null;
  if (parts.length === 0 && !unavailable) return null;

  // Failures and review flags are the urgent ones (red); plain manual-review queue is amber.
  const urgent = summary.failed > 0 || summary.needsReview > 0;
  return (
    <div className={urgent ? 'error-banner' : 'warning-banner'} role="status">
      {parts.length > 0 && <strong>{parts.join(' · ')}</strong>}
      {unavailable && (
        <span style={{ display: 'block', opacity: 0.8 }}>
          Live updates unavailable — showing last known data.
        </span>
      )}
    </div>
  );
}
